import React, { useState, useEffect } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import Cookies from "js-cookie";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuthHandling } from '../useAuthhandling';

function Addedit() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  let { id } = useParams();

  const [add, setAds] = useState([]);

  const [formerror, setError] = useState({});

  const getinfo = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/ad/get-ad/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("a_token")}`,
      },
    });
    if (res.status === 200 ) {
      const data = await res.json();

      setAds(data.data);

    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };

  let name, value;

  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setAds({ ...add, [name]: value });
  };

  const onFileChange = (e) => {
    console.log(e);
    let name = e.target.name;
    setAds({ ...add, [name]: e.target.files[0] });
  };

  const validate = (values) => {
    const errors = {};
    if (!values.adTitle) {
      errors.adTitle = "Title name is required!";
    }

    if (!values.link) {
      errors.link = "Link is required!";
    }
    if (!values.adImage) {
      errors.adImage = "Image is required!";
    } else if (values.adImage.type) {
      if (
        values.adImage.type === "image/jpeg" ||
        values.adImage.type === "image/jpg" ||
        values.adImage.type === "image/png"
      ) {
        if (values.adImage.size > 1024 * 1000) {
          errors.adImage =
            "maximum file size 1 mb...please upload an image less than 1 mb";
        }
      } else {
        errors.adImage = "Only support jpg, jpeg, png image!";
      }
    }

    return errors;
  };
  const PostData = async (e) => {
    e.preventDefault();
    const { adTitle, link, adImage } = add;
    const ress = validate(add);
    setError(ress);
    if (!ress.adTitle && !ress.link && !ress.adImage) {
      const formData = new FormData();
      formData.append("adTitle", add.adTitle);
      formData.append("link", add.link);
      formData.append("status", add.status);
      formData.append("adImg", add.adImage);
      axios
        .put(`${Config.apiurl}/api/v1/crm/ad/update-ad-info/${id}`, formData, {
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200 ) {

            toast.success("Sucessfully updated adds", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setTimeout(() => navigate("/dashboard"), 3000);
    
          } 
          else if(res.status === 401){
            handleUnauthorized();
            PostData();
          }

          else {
            toast.error("Something went wrong", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  };
  useEffect(() => {
    getinfo();
  }, []);
  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Advertisement</h4>
                    <p className="card-description">New Ads</p>
                    <form className="forms-sample" onSubmit={PostData}>
                      {/* <form className="forms-sample"> */}
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">Title</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="Title"
                          name="adTitle"
                          value={add.adTitle}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.adTitle}
                        </label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">Link</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="Link"
                          name="link"
                          value={add.link}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>{formerror.link}</label>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Status</label>

                          <select
                            className="form-control "
                            style={{
                              color: "black",
                              backgroundColor: "#2b2e4c;",
                            }}
                            id="exampleInputUsername1"
                            name="status"
                            onChange={handleInputs}
                            value={add.status}
                          >
                            <option {...(add.status === "1" ? "selected" : "")}>
                              true
                            </option>
                            <option {...(add.status === "0" ? "selected" : "")}>
                              false
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Image</label>
                        <br></br>
                        <input
                          type="file"
                          name="adImage"
                          onChange={onFileChange}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.adImage}
                        </label>
                        <img src={add.adImage} width="200" alt="" />
                      </div>
                      <button
                        type="submit"
                        onClick={PostData}
                        className="btn btn-primary me-2"
                      >
                        Submit
                      </button>
                      <ToastContainer />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Addedit;
